// -*- mode: RJSX; js-indent-level: 2; -*-

import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
  Box,
  Slider,
  Avatar,
} from '@mui/material';
import { colorAsRGBA, textForBackground } from '../util';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1em',
  },
}));

const OpacityChooser = ({value, onChange, color}) => {
  const classes = useStyles();
  const [current, setCurrent] = useState(value);

  const base = colorAsRGBA(color);
  const comma = base.lastIndexOf(',');
  const rgbaCurrent = `${base.slice(0, comma)},${current})`;
  const percentCurrent = Math.round(current * 100);

  return (
    <div className={classes.root} spacing={5}>
      <Box display='flex' flexDirection='row'>
        <Box alignSelf='center'>
          <Slider
              sx={{ width: '200px' }}
              value={current}
              step={0.01}
              min={0}
              max={1}
              onChange={(ev, val) => setCurrent(val)}
              onChangeCommitted={() => onChange(current)}/>
        </Box>
        <Box alignSelf='center' paddingLeft='2em'>
          <Avatar
              style={{
                backgroundColor: rgbaCurrent,
                color: textForBackground(rgbaCurrent),
              }}>
            {percentCurrent > 99 ? '∞' : percentCurrent.toString()}
          </Avatar>
        </Box>
      </Box>
    </div>
  );
};

export default OpacityChooser;
